import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type PaginationBase from "@/components/Pagination.Base.vue";

export default defineMosaicComponent<typeof PaginationBase>("components/Pagination");
